import Component from './InDmImage.vue'
export default Component
export * from './types'
